import React from 'react';

export interface IMargins {
    top: number;
    right: number;
    bottom: number;
    left: number;
}

interface IProps {
    svgHeight: number;
    margins: IMargins;
    stroke?: string;
    strokeWidth?: number;
    text?: {
        x: number;
        y: number;
        value?: string;
        anchor?: string;
    };
}

const VerticalLine: React.FC<IProps> = ({ svgHeight, margins, text, stroke = '#545454', strokeWidth = 0.5 }) => (
    <g>
        <path style={{ stroke, strokeWidth }} d={`M${0},${margins.top} ${0},${svgHeight - margins.bottom}`} />
        {text?.value && (
            <text y={text.y} style={{ fontSize: '80%' }} fill={stroke} textAnchor={text.anchor}>
                {text.value}
            </text>
        )}
    </g>
);

export default VerticalLine;
